"use client";

/**
 * ApiProvider — QueryClientProvider 래퍼
 *
 * useState로 QueryClient 생성: 요청 간 상태 누수 방지 (Next.js SSR 패턴)
 * ReactQueryDevtools: 개발 환경에서만 렌더링
 */
import { useState } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { createQueryClient } from "@/shared/api/query-client";

interface ApiProviderProps {
  children: React.ReactNode;
}

export function ApiProvider({ children }: ApiProviderProps) {
  const [queryClient] = useState(() => createQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {process.env.NODE_ENV === "development" &&
        process.env.NEXT_PUBLIC_HIDE_DEVTOOLS !== "true" && (
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
        )}
    </QueryClientProvider>
  );
}
